export var componentsLocales = {
  placeholder: 'Ничего не выбрано'
};